module.exports = __webpack_public_path__ + "img/right_three.bfd8be16.svg";